import {
  Configuration,
  Domain,
  DOMAINS,
  ExtendedConfiguration,
  ExtendedDomainConfiguration,
} from '../domain-config/domain-config'
import { NextRequest } from 'next/server'
import { merge } from '@/lib/merge'
import { FALLBACK_DOMAIN } from '@/lib/sharedConstants'

export function getCurrentDomainByHost(
  host: string,
  testDomainOverwrite: string | undefined,
): Domain {
  const fallBackDomainOrTestDomainOverwrite = (testDomainOverwrite as Domain) || FALLBACK_DOMAIN

  if (host.includes('localhost') || host.includes('fit-reisen.vercel.app')) {
    return fallBackDomainOrTestDomainOverwrite
  }

  const domain =
    process.env.NODE_ENV == 'production'
      ? host.split('.').slice(-2).join('.')
      : fallBackDomainOrTestDomainOverwrite

  if (domain === 'vercel.app') {
    return Domain.WELLNESSURLAUB_COM
  } else {
    return domain as Domain
  }
}

export function isPublicDomain(req: NextRequest): boolean {
  const host = getHost(req)
  return !host.includes('relaunch.') && !host.includes('fit-reisen.vercel.app')
}

export function getHost(req: NextRequest): string {
  return req.headers.get('host') as string
}

export function getUrlHelper(domain: Domain): (path: string | null) => string {
  return (path: string | null) => {
    return `https://www.${domain}${path || ''}`
  }
}

export async function getConfiguration(domain: Domain): Promise<ExtendedDomainConfiguration> {
  if (!DOMAINS.includes(domain)) {
    domain = Domain.FITREISEN_DE
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const configEntry = (await import(`../domain-config/${domain}`)).default as ExtendedConfiguration

  const extendedConfigEntry = merge<Configuration>([...configEntry.extends, configEntry])

  return {
    ...extendedConfigEntry,
    domain,
    currency: extendedConfigEntry.fallbackCurrency,
  }
}
